import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e0fbb9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Base Cálculo"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ISS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "PIS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "COFINS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IR"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "INSS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_42 = { class: "ant-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "CSLL"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_48 = { class: "ant-row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Crédito"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_51 = { class: "ant-row" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ISS Retido"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_58 = { class: "ant-row" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "A. Tributos"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_63 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_64 = { class: "ant-row" }
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total Base de Cálculo",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalBaseCalculo,
                              "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedImpostos.totalBaseCalculo) = $event)),
                              onValorDigitado: _cache[1] || (_cache[1] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total ISS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalIss,
                              "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedImpostos.totalIss) = $event)),
                              onValorDigitado: _cache[3] || (_cache[3] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total PIS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalPis,
                              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedImpostos.totalPis) = $event)),
                              onValorDigitado: _cache[5] || (_cache[5] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total COFINS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalCofins,
                              "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedImpostos.totalCofins) = $event)),
                              onValorDigitado: _cache[7] || (_cache[7] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total IR",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalIr,
                              "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedImpostos.totalIr) = $event)),
                              onValorDigitado: _cache[9] || (_cache[9] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total INSS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalInss,
                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedImpostos.totalInss) = $event)),
                              onValorDigitado: _cache[11] || (_cache[11] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total CSLL",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalCsll,
                              "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedImpostos.totalCsll) = $event)),
                              onValorDigitado: _cache[13] || (_cache[13] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total Crédito",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalCredito,
                              "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedImpostos.totalCredito) = $event)),
                              onValorDigitado: _cache[15] || (_cache[15] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total ISS Retido",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalIssRetido,
                              "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedImpostos.totalIssRetido) = $event)),
                              onValorDigitado: _cache[17] || (_cache[17] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor aproximado dos tributos",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.totalValorAproximadoTributos,
                              "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedImpostos.totalValorAproximadoTributos) = $event)),
                              onValorDigitado: _cache[19] || (_cache[19] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}